import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import { v1 as uuidv1 } from 'uuid';
import * as Sentry from '@sentry/vue';
import VueAnalytics from 'vue-analytics';

Vue.config.devtools = true;
Vue.config.productionTip = false;

const environment = process.env.VUE_APP_ENVIRONMENT || process.env.NODE_ENV;

Sentry.init({
  dsn: 'https://b8eaef2982f343e1a615cc7212020c72@o200642.ingest.sentry.io/1312167',
  enabled: ['test', 'production'].includes(environment),
  environment,
  release: `${process.env.VUE_APP_NAME}@${process.env.VUE_APP_VERSION}`,
});

let deviceId = localStorage.deviceId;
if (!deviceId) {
  localStorage.deviceId = uuidv1();
}

if (environment === 'production') {
  Vue.use(VueAnalytics, {
    id: 'UA-127852084-1',
    router,
  });
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
